import { createGlobalStyle } from 'styled-components';
import chevron from '../assets/icons/arrowDown.png';
import 'typeface-roboto-slab';

const GlobalStyle = createGlobalStyle`
  html {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      // Set rems
      font-size: 56.25%; // 1rem = 9px
      @media ( ${props => props.theme.breakpoints.sm} ) {
          font-size: 56.25%; // 1rem = 9px
      }
      @media ( ${props => props.theme.breakpoints.md} ) {
          font-size: 62.5%; // 1rem = 10px
      }
      @media ( ${props => props.theme.breakpoints.lg} ) {
          font-size: 62.5%; // 1rem = 10px
      }
      * { box-sizing: border-box; }
  }

  body {
      margin: 0;
      font-family: ${props => props.theme.typeface.serif};
      font-weight: 300;
      color: ${props => props.theme.colours.black};
      background-color: ${props => props.theme.colours.white};
  }

  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6,
  p,
  ol, ul, li,
  code, kbd, pre, samp {
      line-height: 1.5;
      margin-top: 2rem;
      margin-bottom: 2rem;
  }

  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6 {
      font-weight: bold;
      a { text-decoration: none; }
      a:hover { text-decoration: none; }
      &.subtitle {
        color: ${props => props.theme.colours.darkGrey}
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.2rem;
        font-family: ${props => props.theme.typeface.sansSerif}; 
      }
      &.regular { font-weight: 400; }
  }

  h1, .h1 { ${props => props.theme.typeStyles( 5 )}; }
  h2, .h2 { ${props => props.theme.typeStyles( 4 )}; }
  h3, .h3 { ${props => props.theme.typeStyles( 3 )}; }
  h4, .h4 { ${props => props.theme.typeStyles( 2 )}; }
  h5, .h5 { ${props => props.theme.typeStyles( 1 )}; }
  h6, .h6 { ${props => props.theme.typeStyles( 0 )}; }
  p, ul, ol, blockquote { ${props => props.theme.typeStyles( 1 )}; }

  li {
      margin-top: 0;
      margin-bottom: 0;
  }

  small {  ${props => props.theme.typeStyles( -1 )}; }
  
  code, kbd, pre, samp {
      font-family: monospace;
      font-size: 16px;
      white-space: normal;
  }
  
  pre { font-size: 16px; }
  
  ul {
      padding-left: 4rem;
      list-style-type: disc;
  }
  
  ol {
      padding-left: 4rem;
      list-style-type: decimal;
  }
  
  em, i { font-style: italic; }
  
  strong, b { font-weight: bold; }
  
  blockquote {
      font-weight: bold;
      padding-left: 4rem;
  }
  
  a { color: ${props => props.theme.colours.link}; }
  
  sup, sub {
      vertical-align: baseline;
      position: relative;
      top: -0.4em;
  }
  
  sub { top: 0.4em; }
  
  form {
    button {
      margin-top: 4rem;
    }
  }
  
  label {
      font-family: inherit;
      font-weight: bold;
      line-height: 1.2;
      margin-bottom: 1rem;
      display: block;
  }
  
  .input-holder {
     font-weight: bold;
     margin: 1rem 0;
      ${props => props.theme.typeStyles( 3 )};
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      grid-column-gap: 1rem;
      label {
        margin-bottom: 0;
      }
  }
  
  .text-input,
  input[type="text"],
  input[type="password"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="email"],
  input[type="month"],
  input[type="number"],
  input[type="range"],
  input[type="search"],
  input[type="tel"],
  input[type="time"],
  input[type="url"],
  input[type="week"],
  textarea {
      display: block;
      font-family: inherit;
      font-weight: bold;
      font-size: inherit;
      padding: 0.4rem 1rem;
      margin-top: 2rem;
      margin-bottom: 2rem;
      border: 1px ${props => props.theme.colours.black} solid;
      border-radius: 0;
      line-height: 1.6;
      background-color: transparent;
      -webkit-appearance: none;
  }
  
  .file-input,
  input[type="file"],
  .radio-input,
  input[type="radio"],
  .checkbox-input,
  input[type="checkbox"] {
      font-family: inherit;
      font-weight: bold;
  }
  
  .checkboxHolder {
    display: block;
    position: relative;
    width: 100%;
    padding-right: 3.5rem;
    margin: 3rem 0;
    cursor: pointer;
    font-weight: bold;
    ${props => props.theme.typeStyles( 4 )};
    user-select: none;
    // Hide the browser's default checkbox
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      position: absolute;
      top: 0;
      right: 0;
      height: 2.5rem;
      width: 2.5rem;
      background-color: #fff;
      border: 1px solid ${props => props.theme.colours.link};
      /* Create the checkmark/indicator (hidden when not checked) */
      &:after {
        content: "";
        position: absolute;
        display: none;
        left: 0.9rem;
        top: 0.4rem;
        width: 0.5rem;
        height: 1rem;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
    /* On mouse-over, add a grey background color */
    &:hover > input ~ .checkmark {
        background-color: ${props => props.theme.colours.lightGrey2};
    }
    /* When the checkbox is checked, add a blue background */
    input:checked ~ .checkmark {
        background-color: ${props => props.theme.colours.link};
    }
    /* Show the checkmark when checked */
    input:checked ~ .checkmark:after {
      display: block;
    }
  }
  
  select {
      color: ${props => props.theme.colours.link};
      font-family: inherit;
      font-weight: bold;
      display: block;
      font-size: inherit;
      padding: 0 2rem 0 1rem;
      margin: 0;
      width: 100%;
      line-height: 4rem;
      border: none;
      border-radius: 0;
      box-shadow: ${props => props.theme.boxShadow};
      -moz-appearance: none;
      -webkit-appearance: none;
      background: transparent url(${chevron}) no-repeat;
      background-position: center right 1rem;
      background-size: 1.2rem auto;
  
      &::-ms-expand {
          display: none;
      }
  }
  
  .button,
  button,
  input[type="submit"],
  input[type="button"],
  input[type="reset"] {
      display: inline-block;
  
      padding: 0 4rem;
      font-family: ${props => props.theme.typeface.sansSerif}; 
      font-weight: bold;
      ${props => props.theme.typeStyles( 0 )};
      line-height: 4.5rem;
      text-align: center;
      text-decoration: none;
      white-space: nowrap;
      border: 1px solid;
      border-radius: 0;
  
      color: ${props => props.theme.colours.link};
      background-color: transparent;
      cursor: pointer;
      
      &.disabled {
        opacity: 0.2;
      }
  
      &.primary {
        width: 100%;
        line-height: 4.5rem;
        color: ${props => props.theme.colours.white};
        border-color: transparent;
        background-color: ${props => props.theme.colours.link};
      }
      &:hover, &:active {
          color: ${props => props.theme.colours.white};
          border: 1px solid ${props => props.theme.colours.link};
          background-color: ${props => props.theme.colours.link};
      }
      &.small {
        line-height: 3.5rem;
        ${props => props.theme.typeStyles( -1 )};
        padding: 0 1rem;
      }
      &.text {
        width: inherit;
        font-size: 2rem;
        font-family: ${props => props.theme.typeface.serif};
        color: ${props => props.theme.colours.link};
        border-color: transparent;
        background-color: transparent;
        padding-left: 0;
        padding-right: 0;
        &:hover { 
          color: ${props => props.theme.colours.link};
          background-color: transparent; 
          text-decoration: underline;
        }
        &.skip {
          font-weight: normal;
          color: ${props => props.theme.colours.darkGrey};
        }
      }
      &.circle {
        width: 3rem;
        height: 3rem;
        ${props => props.theme.typeStyles( -2 )};
        padding: 0;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-color: transparent;
        color: ${props => props.theme.colours.white};
        background-color: ${props => props.theme.colours.link};
        svg {
          width: 1.2rem;
          height: 1.2rem;
        }
      }
      &.button-icon {
        display: flex;
        align-items: center;
        > svg { fill: ${props => props.theme.colours.link}; padding-left: 1rem; }
      }
      &.icon-only, &.icon-only:hover {
        background-color: transparent;
        border-color: transparent;
        padding: 0;
        line-height: 0;
      }
  }
  
  .errorMsg {
      color: ${props => props.theme.colours.error};
  }

  .highlight-yellow {
    background-color: ${props => props.theme.colours.ttcYellow};
  }
`;

export default GlobalStyle;
